import { PlusCircleIcon } from '@phosphor-icons/react/dist/ssr/PlusCircle'

export const CreateLabel = ({ inputValue }: { inputValue: string }) => (
  <div className="flex items-center gap-2">
    <PlusCircleIcon className="size-4" />
    <span>{inputValue}</span>
  </div>
)
